import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, Typography,  Select ,  InputLabel , MenuItem, Switch } from '@mui/material';
import { makeStyles } from '@mui/styles';

import COLOR from 'utils/constants/color';
import styled from 'styled-components';
import { Col, Row } from 'antd';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------



//  -- Constants ----------------------

// import AudioRecorder from 'features/AudioRecorder';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const LABEL = ['a', 'b', 'c', 'd', 'e']

const Container = styled.div`
    width: 100%;
`;

const Description = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin-bottom: 25px;
`;

const AssignmentDescription = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
`;
const AssignmentTitle = styled.span`
    color: ${COLOR.black100};
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
`;


const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '25px',
        width: '300px'
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    },
    checkroot: {
        display: 'flex',
        flexDirection: 'column'
      },
      checkformControl: {
        minWidth: 300,
      },
      checksectionTitle: {
      },
      formGroup: {
        flexDirection: 'row', // Arrange checkboxes in a row
        gap:12
      },
      checkbox: {
        '&.Mui-checked': {
          color: COLOR.green100, // Custom checked color (green)
        },
      },


}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const GRADE_LEVEL_OPTIONS = [
    'NoviceLow',
    'NoviceMid',
    'NoviceHigh',
    'IntermediateLow',
    'IntermediateMid',
    'IntermediateHigh',
    'AdvanceLow',
    'AdvanceMid',
    'AdvanceHigh',
];

const getValidGradeLevel = (value, fallback) => {
    if (GRADE_LEVEL_OPTIONS.includes(value)) {
        return value;
    }
    return fallback;
};

export const CheckCreteia = ({ creteria ={} , onCreteriaChange=()=>{} , original_conf , is_exam = false, is_editing = false, assignmentCategory = "" }) => {
    const classes = useStyles();
    const [copied_original,setCopiedOriginal] = useState()
    const isSpeakingAndListeningWithExam = useMemo(() => {
        // if(is_exam){
        //     if(assignmentCategory === 'Speaking' || assignmentCategory === 'Listening'){
        //         return false;
        //     }
        //     return true;
        // }
        return false;
    }, [assignmentCategory, is_exam])
    // const hasInitialized = useRef(false)
    const prevCreteriaRef = useRef(creteria)
    const prevIsExamRef = useRef(is_exam)
    const [selectedSections, setSelectedSections] = useState({
        sentenceStructure: typeof creteria.sentenceStructure === 'boolean' ? creteria.sentenceStructure : (is_exam ? true : false),
        grammar: typeof creteria.grammar === 'boolean' ? creteria.grammar : (is_exam ? true : false),
        orthography: typeof creteria.orthography === 'boolean' ? creteria.orthography : (is_exam ? true : false),
        sectionContent: typeof creteria.sectionContent === 'boolean' ? creteria.sectionContent : (is_exam ? true : false),
        language_feedback: creteria.language_feedback || 'SPANISH',
        grade_level: getValidGradeLevel(creteria.grade_level, is_exam ? 'AdvanceHigh' : 'NoviceLow'),
    });
    useEffect(() => {
        prevCreteriaRef.current = creteria;
        prevIsExamRef.current = is_exam;

        // const isCreteriaObject = creteria && typeof creteria === 'object' && !Array.isArray(creteria);
        // const hasCreteriaData = isCreteriaObject && Object.keys(creteria).length > 0;
        if (!creteria && typeof creteria !== 'object' || Array.isArray(creteria)) {
            return;
        }
        const creteriaEntries = Object.entries(creteria || {});
        const hasOnlyEmptyCreteria =
            creteriaEntries.length === 0 || creteriaEntries.every(([, v]) => v === undefined || v === null);
        const hasValidIncomingGradeLevel = GRADE_LEVEL_OPTIONS.includes(creteria?.grade_level);
        let computedNextSections = null;

        setSelectedSections((prev) => {
            const nextSections = {
                sentenceStructure: typeof creteria.sentenceStructure === 'boolean' ? creteria.sentenceStructure : (prev.sentenceStructure ?? (is_exam ? true : false)),
                grammar: typeof creteria.grammar === 'boolean' ? creteria.grammar : (prev.grammar ?? (is_exam ? true : false)),
                orthography: typeof creteria.orthography === 'boolean' ? creteria.orthography : (prev.orthography ?? (is_exam ? true : false)),
                sectionContent: typeof creteria.sectionContent === 'boolean' ? creteria.sectionContent : (prev.sectionContent ?? (is_exam ? true : false)),
                language_feedback: creteria.language_feedback || prev.language_feedback || 'SPANISH',
                grade_level: hasValidIncomingGradeLevel
                    ? creteria.grade_level
                    : (prev.grade_level || (is_exam ? 'AdvanceHigh' : 'NoviceLow')),
            };
            computedNextSections = nextSections;
            return nextSections;
        });

        if (!is_editing && hasOnlyEmptyCreteria && computedNextSections) {
            onCreteriaChange(computedNextSections);
        }
        // if (hasRequiredFields) {
        // setSelectedSections({
        //     sentenceStructure: is_exam ? true : creteria.sentenceStructure || false,
        //     grammar: is_exam ? true : creteria.grammar || false,
        //     orthography: is_exam ? true : creteria.orthography || false,
        //     sectionContent: is_exam ? true : creteria.sectionContent || false,
        //     language_feedback: creteria.language_feedback || 'SPANISH',
        //     grade_level: is_exam ? 'Advance' : (creteria.grade_level || 'Advance'),
        // });
        //     hasInitialized.current = true;
        // } else if (!hasInitialized.current) {
        //     const defaultValues = {
        //         sentenceStructure: is_exam ? true : (hasCreteriaData && creteria.sentenceStructure) || false,
        //         grammar: is_exam ? true : (hasCreteriaData && creteria.grammar) || false,
        //         orthography: is_exam ? true : (hasCreteriaData && creteria.orthography) || false,
        //         sectionContent: is_exam ? true : (hasCreteriaData && creteria.sectionContent) || false,
        //         language_feedback: (hasCreteriaData && creteria.language_feedback) || 'SPANISH',
        //         grade_level: is_exam ? 'Advance' : ((hasCreteriaData && creteria.grade_level) || 'Novice'),
        //     };
        //     setSelectedSections(defaultValues);
        //     onCreteriaChange(defaultValues);
        //     hasInitialized.current = true;
        // }
    }, [creteria, is_exam, is_editing, onCreteriaChange])
    const handleChange = (event) => {
        setSelectedSections({
          ...selectedSections,
          [event.target.name]: event.target.checked,
        });
        onCreteriaChange({
            ...selectedSections,
            [event.target.name]: event.target.checked,
        })
      };
    const handleChangeLanguage = (event) => {
        setSelectedSections({
          ...selectedSections,
          'language_feedback': event.target.value,
        });
        onCreteriaChange({
            ...selectedSections,
            'language_feedback': event.target.value,
        })
      };
    const handleChaneGradeLevel = (event) => {
        setSelectedSections({
          ...selectedSections,
          'grade_level': event.target.value,
        });
        onCreteriaChange({
            ...selectedSections,
            'grade_level': event.target.value,
        })
      };
      const onCopyOriginal =(e)=>{
        if(e.target.checked){
           if(original_conf&&Object.keys(original_conf).length>0){
            onCreteriaChange(original_conf)
           }
        }
        setCopiedOriginal(e.target.checked)
      }
    return (<div className={classes.checkroot}>
        <Typography variant="subtitle2" className={classes.checksectionTitle}>
           AI Open-Ended Auto Grading  
            {original_conf?<FormControlLabel style={{ marginLeft:4}} control={<Switch onChange={onCopyOriginal} checked={copied_original}  />} label="Same as original" />:null}
        </Typography>
        <FormControl component="fieldset" className={classes.checkformControl}>
            <FormGroup className={classes.formGroup}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.sentenceStructure}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="sentenceStructure"
                            color="primary"
                        />
                    }
                    label="Sentence Structure"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.grammar}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="grammar"
                            color="primary"
                        />
                    }
                    label="Grammar"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.orthography}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="orthography"
                            color="primary"
                        />
                    }
                    label="Orthography"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedSections.sectionContent}
                            onChange={handleChange}
                            className={classes.checkbox}
                            name="sectionContent"
                            color="primary"
                        />
                    }
                    label="Section Content"
                />
            </FormGroup>
        </FormControl>
        <Row gutter={[16, 8]} style={{ marginTop: 8 }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                    <InputLabel id="language_feedback" style={{ background: 'white' }}>
                        Language for AI Feedback
                    </InputLabel>
                    <Select
                        labelId="language_feedback"
                        id="language_feedback"
                        required={false}
                        value={selectedSections.language_feedback || 'SPANISH'}
                        onChange={handleChangeLanguage}
                        label="Language for AI Feedback"
                    >
                        <MenuItem value={'ENGLISH'}>English</MenuItem>
                        <MenuItem value={'SPANISH'}>Spanish</MenuItem>
                    </Select>
                </FormControl>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth>
                    <InputLabel id="grade_level" style={{ background: 'white' }}>
                        Level for AI grading
                    </InputLabel>
                    <Select
                        labelId="grade_level"
                        id="grade_level"
                        required={false}
                        disabled={isSpeakingAndListeningWithExam}
                        value={getValidGradeLevel(selectedSections.grade_level, 'NoviceLow')}
                        onChange={handleChaneGradeLevel}
                        label="Level for AI grading"
                    >
                        <MenuItem value={'NoviceLow'}>Novice low</MenuItem>
                        <MenuItem value={'NoviceMid'}>Novice mid</MenuItem>
                        <MenuItem value={'NoviceHigh'}>Novice high</MenuItem>

                        <MenuItem value={'IntermediateLow'}>Intermediate low</MenuItem>
                        <MenuItem value={'IntermediateMid'}>Intermediate mid</MenuItem>
                        <MenuItem value={'IntermediateHigh'}>Intermediate high</MenuItem>

                        <MenuItem value={'AdvanceLow'}>Advance low</MenuItem>
                        <MenuItem value={'AdvanceMid'}>Advance mid</MenuItem>
                        <MenuItem value={'AdvanceHigh'}>Advance high</MenuItem>
                    </Select>
                </FormControl>
            </Col>
        </Row>
    </div>)
}
export const AiConfiguration = ({ config, onChangeConfig , original_conf , is_exam, is_editing = false, assignmentCategory = "" }) => {
    const rawCreteria =
        config?.creteria && typeof config.creteria === 'object' && !Array.isArray(config.creteria)
            ? config.creteria
            : null;
    const rawCriteria =
        config?.criteria && typeof config.criteria === 'object' && !Array.isArray(config.criteria)
            ? config.criteria
            : null;
    const normalizedCreteria = rawCreteria || rawCriteria || {};
    const mergedCreteria = {
        ...normalizedCreteria,
        ...(GRADE_LEVEL_OPTIONS.includes(normalizedCreteria?.grade_level)
            ? { grade_level: normalizedCreteria.grade_level }
            : (GRADE_LEVEL_OPTIONS.includes(config?.grade_level) ? { grade_level: config.grade_level } : {})),
    };
    return (  <Row style={{ display: "flex", position: "relative", width: "100%", marginTop: 8 }}>
        <CheckCreteia
            creteria={mergedCreteria}
            onCreteriaChange={(v) =>
                onChangeConfig({
                    ...(config && typeof config === 'object' ? config : {}),
                    creteria: v,
                    criteria: v,
                    grade_level: v.grade_level
                })
            }
            original_conf={original_conf}
            is_exam={is_exam}
            is_editing={is_editing}
            assignmentCategory={assignmentCategory}
        />
    </Row>)
}